// extracted by mini-css-extract-plugin
module.exports = {"sslIconWrapper":"SSLIcon_sslIconWrapper__1JCb3","sslIcon":"SSLIcon_sslIcon__37EBi"};